export default "__VITE_ASSET__BxpJrGRP__"